const ComponentsLookup = {
  "default-footer": "DefaultFooter78bf1e0e68f0423c9547441a9a071ce7"
}

export default ComponentsLookup;